module.exports = __webpack_public_path__ + "static/media/28DGC4.ab8c9bbe.jpg";